//DG Scripts
function addOneToIndicator() {
  const inCartCount = document.getElementById("inCartCount");
  const inCartCountMobile = document.getElementById("inCartCountMobile");
  let count = parseInt(inCartCount.textContent, 10);
  count = isNaN(count) ? 0 : count;
  count = count + 1;
  inCartCount.textContent = count;
  inCartCountMobile.textContent = count;
}

//for quick add to cart cards 

function dg_updateVariantId(selectElement, moneyFormat) {
  const form = selectElement.closest('form');
  const variantPicker = form.querySelector('[data-variant-picker]');
  const variantData = JSON.parse(form.querySelector('[data-variants]').textContent);
  const selects = variantPicker.querySelectorAll('select');
  const selectedOptions = Array.from(selects).map(select => select.value);

  // Debugging: Log variant data and selected options
  console.log('Variant Data:', variantData);
  console.log('Selected Options:', selectedOptions);

  // Find the matching variant
  const selectedVariant = variantData.find(variant =>
    variant.options.every((option, index) => option === selectedOptions[index])
  );

  // Update the hidden variant ID input
  const variantIdInput = form.querySelector('[data-variant-id]');
  const priceWrapper = form.closest('.product-card-outer-wrapper').querySelector('[data-price-wrapper]');
  const priceElement = priceWrapper.querySelector('[data-price]');
  const comparePriceElement = priceWrapper.querySelector('[data-compare-price]');
  const pricePrefixElement = priceWrapper.querySelector('[data-price-prefix]');

  if (selectedVariant) {
    variantIdInput.value = selectedVariant.id;

    // Debugging: Log selected variant price
    console.log('Selected Variant Price (cents):', selectedVariant.price);

    // Update price display
    priceElement.innerHTML = dg_formatMoney(selectedVariant.price) + '&nbsp;';
    if (selectedVariant.compare_at_price) {
      if (comparePriceElement) {
        comparePriceElement.innerHTML = dg_formatMoney(selectedVariant.compare_at_price);
        comparePriceElement.classList.remove('hidden');
      } else {
        const newComparePrice = document.createElement('span');
        newComparePrice.className = 'text-darker opacity-50 font-medium line-through';
        newComparePrice.setAttribute('data-compare-price', '');
        newComparePrice.innerHTML = dg_formatMoney(selectedVariant.compare_at_price);
        priceWrapper.appendChild(newComparePrice);
      }
    } else if (comparePriceElement) {
      comparePriceElement.classList.add('hidden');
    }

    // Update price prefix for variable pricing
    if (pricePrefixElement) {
      pricePrefixElement.classList.toggle('hidden', !variantData.some(v => v.price !== selectedVariant.price));
    }

    // Enable/disable buttons based on variant availability
    const addToCartButton = form.querySelector('[data-add-to-cart]');
    const soldOutButton = form.querySelector('[data-button-sold-out]');
    const selectOptionsButton = form.querySelector('[data-button-select-options]');
    //const pricePrefix = form.querySelector('[data-price-prefix]');//new
    if (selectedVariant.available) {
      addToCartButton.classList.remove('hidden');
      addToCartButton.disabled = false;
      soldOutButton.classList.add('hidden');
      selectOptionsButton.classList.remove('peer-checked:group-[]/content:block');
      selectOptionsButton.classList.add('hidden');
      pricePrefixElement.innerHTML = "Option Price&nbsp;";
    } else {
      addToCartButton.classList.add('hidden');
      soldOutButton.classList.remove('hidden');
      selectOptionsButton.classList.remove('peer-checked:group-[]/content:block');
      selectOptionsButton.classList.add('hidden');
    }
  } else {
    // If no valid variant is found, reset to default and disable buttons
    priceElement.innerHTML = dg_formatMoney(variantData[0].price) + '&nbsp;';
    if (variantData[0].compare_at_price && comparePriceElement) {
      comparePriceElement.innerHTML = dg_formatMoney(variantData[0].compare_at_price);
      comparePriceElement.classList.remove('hidden');
    } else if (comparePriceElement) {
      comparePriceElement.classList.add('hidden');
    }
    if (pricePrefixElement) {
      pricePrefixElement.classList.remove('hidden');
    }
    const addToCartButton = form.querySelector('[data-add-to-cart]');
    const soldOutButton = form.querySelector('[data-button-sold-out]');
    const selectOptionsButton = form.querySelector('[data-button-select-options]');
    addToCartButton.classList.add('hidden');
    soldOutButton.classList.add('hidden');
    selectOptionsButton.classList.remove('hidden');
    selectOptionsButton.disabled = true;
  }
}

// Helper function to format price using Shopify's money format
function dg_formatMoney(cents) {
  // Ensure cents is a number and not undefined
  const centsValue = Number(cents);
  if (isNaN(centsValue) || centsValue < 0) {
    console.error('Invalid price input:', cents);
    return '$0.00'; // Fallback for invalid price
  }

  // Convert cents to dollars with two decimal places
  const amount = (centsValue / 100).toFixed(2);
  const amountNoDecimals = Math.floor(centsValue / 100).toString();
  const amountWithComma = amount.replace('.', ',');
  const amountNoDecimalsWithComma = amountNoDecimals.replace('.', ',');

  // Debugging: Log values for verification
  console.log('Money Format:', moneyFormat);
  console.log('Cents:', centsValue, 'Amount:', amount, 'Amount No Decimals:', amountNoDecimals, 'Amount with Comma:', amountWithComma);

  // Replace Shopify money format placeholders
  let formattedPrice = moneyFormat
    .replace('{{amount}}', amount)
    .replace('{{amount_no_decimals}}', amountNoDecimals)
    .replace('{{amount_with_comma_separator}}', amountWithComma)
    .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma);

  // Check for unresolved placeholders to avoid Liquid parsing issues
  if (formattedPrice.includes('{' + '{')) {
    console.warn('Money format contains unresolved placeholders:', moneyFormat);
    formattedPrice = '$' + amount; // Fallback to basic dollar format
  }

  return formattedPrice;
}

//for quick add to cart cards
function updateVariantId(selectElement) {
  const form = selectElement.closest('form');
  const variantPicker = form.querySelector('[data-variant-picker]');
  const variantData = JSON.parse(form.querySelector('[data-variants]').textContent);
  const selects = variantPicker.querySelectorAll('select');
  const selectedOptions = Array.from(selects).map(select => select.value);

  // Find the matching variant
  const selectedVariant = variantData.find(variant =>
    variant.options.every((option, index) => option === selectedOptions[index])
  );

  // Update the hidden variant ID input
  const variantIdInput = form.querySelector('[data-variant-id]');
  if (selectedVariant) {
    variantIdInput.value = selectedVariant.id;
    // Enable the "Add to Cart" button if variant is available
    const addToCartButton = form.querySelector('[data-add-to-cart]');
    const soldOutButton = form.querySelector('[data-button-sold-out]');
    const selectOptionsButton = form.querySelector('[data-button-select-options]');
    if (selectedVariant.available) {
      addToCartButton.classList.remove('hidden');
      addToCartButton.disabled = false;
      soldOutButton.classList.add('hidden');
      selectOptionsButton.classList.remove('peer-checked:group-[]/content:block');
      selectOptionsButton.classList.add('hidden');
      //selectOptionsbutton.setAttribute("style", "display:none;");//DG added 9-9-2025 @ 11:47PM
    } else {
      addToCartButton.classList.add('hidden');
      soldOutButton.classList.remove('hidden');
      selectOptionsButton.classList.remove('peer-checked:group-[]/content:block');
      selectOptionsButton.classList.add('hidden');
      //selectOptionsbutton.setAttribute("style", "display:none;");//DG added 9-9-2025 @ 11:47PM
    }
  } else {
    // If no valid variant is found, keep buttons disabled
    const addToCartButton = form.querySelector('[data-add-to-cart]');
    const soldOutButton = form.querySelector('[data-button-sold-out]');
    const selectOptionsButton = form.querySelector('[data-button-select-options]');
    addToCartButton.classList.add('hidden');
    soldOutButton.classList.add('hidden');
    selectOptionsButton.classList.remove('hidden');
    selectOptionsButton.disabled = true;
  }
}
